import { useFetch } from 'app/queryProvider';

interface SubscriptionLinkResponse {
  subscription_link: string;
}

interface UseSubscriptionLinkOptions {
  subscriptionId?: string;
  enabled?: boolean;
}

export const useSubscriptionLink = ({ subscriptionId, enabled = true }: UseSubscriptionLinkOptions) => {
  const shouldFetch = enabled && !!subscriptionId;

  const { data, isLoading, error, refetch } = useFetch<SubscriptionLinkResponse>({
    url: `/${subscriptionId}/subscription-link`,
    queryKey: [['subscription', 'link', subscriptionId || '']],
    resource: { name: 'subscriptions' },
    options: {
      enabled: shouldFetch,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 2,
    },
  });

  return {
    subscriptionLink: data?.subscription_link,
    isLoading,
    error,
    refetch,
  };
};
